import { useQuery } from '@tanstack/react-query';
import type { TopRevenueLocationsResponse, TopRevenueRange } from '@evi/shared';
import { fetchTopRevenueLocations } from '@/lib/api';

/**
 * Top revenue locations widget. Range parameter is part of the
 * query key so toggling 7d ↔ 30d swaps the cached entry rather
 * than refetching the same range. Live: session events refetch it
 * through LiveUpdatesProvider; no poll.
 */
export function useTopRevenueLocations(range: TopRevenueRange) {
  return useQuery<TopRevenueLocationsResponse>({
    queryKey: ['dashboard', 'top-revenue-locations', range],
    queryFn: () => fetchTopRevenueLocations(range),
    staleTime: 60_000,
  });
}
